import { Component, TemplateRef, OnInit } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
@Component({
  selector: "app-patient-notifications",
  templateUrl: "./patient-notifications.component.html",
})
export class PatientNotificationsComponent implements OnInit {
  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) {}
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-custom notification-popup br-44" })
    );
  }
  ngOnInit() {}
}
